import Style from "./footer.tailwind";

export function Footer() {
  return (
      <footer className={Style.footer}>
        <p
          className={Style.copyright}
        >ALL RIGHTS RESERVED © GRAPEVINE FOOTBALL - WEBSITE POWERED BY GOOD SOFTWARE DEV</p>
      </footer>
  );
}
